import { render } from "./FaqSection.vue?vue&type=template&id=66cc0b36&scoped=true"
import script from "./FaqSection.vue?vue&type=script&lang=js"
export * from "./FaqSection.vue?vue&type=script&lang=js"

import "./FaqSection.vue?vue&type=style&index=0&id=66cc0b36&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cc0b36"]])

export default __exports__